export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/TR-c5fe967bb2633c507e5032d5d5c75890.png";